import React, { Component } from 'react'
import './styles.css'
import { apiEmployee } from '../../services/apiamrg'
import Header from '../../components/header'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import 'react-confirm-alert/src/react-confirm-alert.css'
import { Squares } from "react-activity";
import { Input } from '@material-ui/core'
import Select from 'react-select'
import moment from 'moment'
const estadoInicial = {
    bem: {},

    Chave: 0,
    Descricao: '',
    Codigo: '',
    cliente: '',
    Data_Aquisicao: '',

    textOptions: '',

    clientesOptions: [],

    loading: false,
    redirect: false,
}

class AddBem extends Component {

    state = {
        ...estadoInicial,
    }

    componentDidMount = async () => {
        const { id } = this.props.match?.params;

        if (id != 0) {
            this.loadBem(id);
        }
        this.loadAll();
    }

    loadAll = async () => {
        const clientesOptions = await apiEmployee.get(`todaspessoas`).then(res => res.data).catch(err => []);
        
        await this.setState({
            clientesOptions: [{ label: '---', value: '' }, ...clientesOptions.map((c) => ({ label: c.Nome, value: c.Chave }))],
        })
    }

    loadBem = async (id) => {
        const bem = await apiEmployee.get(`pegarbem/${id}`).then(res => res.data).catch((err) => ({}));

        this.setState({
            bem,
            Chave: id,
            Codigo: bem.Codigo,
            Descricao: bem.Descricao,
            cliente: bem.cliente,
            Data_Aquisicao: moment(bem.Data_Aquisicao).isValid ? moment(bem.Data_Aquisicao).format("YYYY-MM-DD") : ""
        })
    }

    saveBem = async () => {
        if (this.state.Chave != 0) {
            await apiEmployee.put(`atualizarbem/${this.state.Chave}`, {
                Descricao: this.state.Descricao,
                Codigo: this.state.Codigo,
                Data_Aquisicao: moment(this.state.Data_Aquisicao).isValid ? moment(this.state.Data_Aquisicao) : undefined,
                Cliente: this.state.cliente,
                Empresa: this.props.empresa
            }).then(res => {
                this.setState({ redirect: true })

            }).catch(err => console.error(err))
        } else if (this.state.Chave == 0) {
            await apiEmployee.post(`inserirbem`, {
                Descricao: this.state.Descricao,
                Codigo: this.state.Codigo,
                Data_Aquisicao: moment(this.state.Data_Aquisicao).isValid ? moment(this.state.Data_Aquisicao) : undefined,
                Cliente: this.state.cliente,
                Empresa: this.props.empresa
            }).then(res => {
                this.setState({ redirect: true })

            }).catch(err => console.error(err))
        }
    }

    filterOptions = (item) => {
        if (!this.state.textOptions) {
            return true;
        }

        return item?.label?.toLowerCase().indexOf(this.state.textOptions?.toLowerCase()) != -1;
    }

    render() {
        const validations = []
        validations.push(this.state.ship_name && this.state.ship_name.trim().length >= 3)


        //o formulário só será válido se todas as validações forem verdadeiras, com este reduce implementado
        const validForm = validations.reduce((t, a) => t && a)

        return (
            <div>
                {this.state.redirect &&
                    <Redirect to={'/admin/bens'} />
                }
                <Header voltarBem />

                <div className='titulo100'><span>Bem</span></div>

                <div className='centrom'>

                    <div className='col-9 row containeralterarcardapio'>
                        <div className='col-6 contcard'>
                            <span>Código</span>
                            <Input value={this.state.Codigo} onChange={(a) => this.setState({ Codigo: a.currentTarget.value })} />

                            <span>Nenhum valor</span>
                        </div>
                        <div className='col-6 contcard'>
                            <span>Data de Aquisição</span>
                            <Input disableUnderline={true} className="input-general" type="date" value={this.state.Data_Aquisicao} onChange={(a) => this.setState({ Data_Aquisicao: a.currentTarget.value })} />

                            <span>Nenhum valor</span>
                        </div>
                        <div className='col-6 contcard'>
                            <span>Descrição</span>
                            <Input disableUnderline={true} className="input-general" value={this.state.Descricao} onChange={(a) => this.setState({ Descricao: a.currentTarget.value })} />

                            <span>Nenhum valor</span>
                        </div>

                        <div className='col-6 contcard'>
                            <span>Cliente</span>
                            {/*console.log(this.state.clientesOptions.filter(this.filterOptions))*/}
                            <Select value={this.state.clientesOptions.find((opt) => opt.value === this.state.cliente)} options={this.state.clientesOptions.filter(this.filterOptions).splice(0, 25)} onChange={a => this.setState({ cliente: a.value })} onInputChange={(a) => this.setState({ textOptions: a })} />
                            <span>Não Selecionado</span>
                        </div>

                        <div className='col-12 contvtt'>
                            <button type='button' onClick={() => this.saveBem()}>Salvar</button>

                            {this.state.loading && <Squares color={'black'} size={40} speed={0.5} />}
                        </div>

                    </div>

                </div>



            </div>
        )
    }
}

const mapStateToProps = ({ user, servidor }) => {
    return {
        token: user.token,
        id: user.id,
        empresa: user.empresa,
        online: servidor.online
    }
}

export default connect(mapStateToProps, null)(AddBem)